import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Standard from "../Standard";
import logo from "../../branding/current/logo.png";
import logoDark from "../../branding/current/logo_dark.png";
import parseQueryParams from "../../modules/parse-query-params";
import { CALL_TO_UNREGISTERED } from "../../actions/actionTypes";

import { call } from "../../actions/sipActions";
import { loadServices } from "../../actions/serviceActions";

export class Ready extends React.Component {
  componentDidMount() {
    const token = this.props.router.location.search.substr(1);
    const tokenValue = parseQueryParams(token);
    if (this.props.restrictNumbers) {
      if (this.props.callableNumbers.length === 0) {
        this.props.loadServices().then(() => {
          this.makeCall(tokenValue);
        });
      } else {
        this.makeCall(tokenValue);
      }
    } else {
      this.makeCall(tokenValue);
    }
  }

  makeCall(values) {
    if (this.props.callableNumbers.some(e => e.sipaddress === values.to)) {
      this.props.call(
        values.to,
        this.props.audio,
        this.props.video,
        this.props.text,
        values.ivr,
        values.ref
      );
    } else {
      this.props.dispatch({ type: CALL_TO_UNREGISTERED });
    }
  }

  ready = () => {
    return <div></div>;
  };

  render() {
    const { contrast, l10n } = this.props;
    return (
      <Standard
        logo={logo}
        logoDark={logoDark}
        contrast={contrast}
        l10n={l10n}
        include={this.ready()}
      />
    );
  }
}

Ready.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
  router: state.router,
  audio: state.config.audio,
  video: state.config.video,
  text: state.config.mode.safetext,
  restrictNumbers: state.config.mode.restrict,
  callableNumbers: state.service.services,
  done: state.done,
});

const mapDispatchToProps = dispatch => {
  return {
    loadServices: () => {
      return dispatch(loadServices());
    },
    dispatch: action => {
      return dispatch(action);
    },
    call: (to, audio, video, text, ivr, ref) => {
      return dispatch(call(to, audio, video, text, ivr, ref));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ready);



// WEBPACK FOOTER //
// ./src/kiosk/callStates/Ready.jsx